import api from '../_api'
import {
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST,
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS,
    FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS,
    FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED
} from './mutation-type'

const fetchAllConsolidatedProductDetail = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, month, productCodes }) => {
    commit(FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST)
    try {
        const { status, data } = await api.fetchAllConsolidatedProductDetail({ qtype, projectIdx, groupIdx, month, productCodes }, rootGetters.requiredService)
        commit(FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS, { status, data })
        return data
    } catch (error) {
        commit(FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED, error)
        throw error
    }
}

const fetchAllConsolidatedProducts = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, month }) => {
    commit(FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST)
    try {
        const { status, data } = await api.fetchAllConsolidatedProductDetail({ qtype, projectIdx, groupIdx, month, productCodes: [] }, rootGetters.requiredService)
        commit(FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS, { status, data })
        return true
    } catch (error) {
        commit(FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED, error)
        throw error
    }
}
export default {
    fetchAllConsolidatedProductDetail,
    fetchAllConsolidatedProducts
}
